import styled, { css } from 'styled-components'
import { Devices, Spacings, Text } from '@styles'
import { BaseWrapper, H6 } from '@base'

export const AdminWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`
export const StepWrapper = styled(BaseWrapper)`
	flex-grow: 1;
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	${({ isFlex }) => {
		if (isFlex) {
			return css`
				display: flex;
				flex-direction: column;
			`
		}
	}}
`
export const StepTopWrapper = styled(StepWrapper)`
	padding: 0;
	flex-grow: 0;
	margin-bottom: ${Spacings.SPACING_4B};
	display: flex;

	button {
		min-width: fit-content;
	}
`
export const BannerText = styled.div`
	display: flex;
	align-items: center;
	flex-grow: 1;
`
export const InitialAdminHeaderWrapper = styled(BaseWrapper)`
	margin-bottom: ${Spacings.SPACING_4B};
`
const FormSection = styled.div`
	padding: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_4B};
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.searchgrey};
	display: block;
	@media ${Devices.mobile} {
		display: flex;
	}
`
export const InitialAdminFormWrapper = styled(FormSection)`
	padding: ${Spacings.SPACING_2B} 0 ${Spacings.SPACING_2B};
	&:last-of-type {
		margin-bottom: 0;
	}
`

export const SectionItemWrapper = styled.div`
	flex-shrink: unset;
	margin-top: ${Spacings.SPACING_2B};
	display: flex;
	flex-wrap: wrap;
	& > div {
		&:nth-child(2) {
			margin-left: 0px;
		}
		&:nth-child(3) {
			margin-left: 0px;
		}
		&:nth-child(4) {
			margin-left: 0px;
		}
	}

	@media ${Devices.mobile} {
		& > div {
			&:nth-child(2) {
				margin-left: 10px;
			}
			&:nth-child(3) {
				margin-left: 10px;
			}
			&:nth-child(4) {
				margin-left: 10px;
			}
		}
	}
`

export const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin: ${Spacings.SPACING_2B} 0 ${Spacings.SPACING_2B} 0;
`
export const FormWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media ${Devices.tablet} {
		flex-direction: row;
		border-radius: ${Spacings.SPACING_2B};
		flex-wrap: wrap;
	}
`

export const FormItemWrapper = styled.div`
	background: ${({ theme }) => theme.palette.background.white};
	${({ inIsolation }) => {
		if (!inIsolation) {
			return css`
				padding: ${Spacings.SPACING_4B};
				box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
				margin-bottom: ${Spacings.SPACING_4B};
			`
		}
	}}

	pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
	opacity: ${({ disabled }) => (disabled ? '0.5' : 1)};
	display: flex;
	flex-direction: column;

	@media ${Devices.tablet} {
		flex: 1 1 0;
		border-radius: ${Spacings.SPACING_2B};
		flex-basis: ${({ fullWidth }) => (fullWidth ? '100%' : 'calc(50% - .5rem)')};
		max-width: ${({ fullWidth }) => (fullWidth ? '100%' : 'calc(50% - .5rem)')};

		&:first-of-type {
			margin-right: ${Spacings.SPACING_4B};
		}
	}
`

export const InfoWrapper = styled.div`
	padding-top: ${Spacings.SPACING_2B};
`

export const Heading = styled(H6)`
	color: ${({ theme }) => theme.palette.text.label};
	font-weight: ${Text.BOLD_600};
	@media ${Devices.tablet} {
		margin-right: ${Spacings.SPACING_2B};
	}
`
export const CardWapper = styled.div`
	display: flex;
	margin-top: 10px;
`
export const CardInfo = styled.div`
	${({ isLeft, isRight }) => {
		if (isLeft) {
			return css`
				flex: 1;
				display: flex;
				justify-content: space-between;
			`
		}
		if (isRight) {
			return css`
				flex: 3;
				margin-left: 10px;
			`
		}
	}}
`
